@use 'sass:math';
@use '@ongov/ontario-design-system-global-styles/dist/styles/scss/1-variables/spacing.variables' as spacing;
@use '@ongov/ontario-design-system-global-styles/dist/styles/scss/1-variables/breakpoints.variables' as breakpoints;

.ontario-card-collection__container {
	display: flex;
	flex-wrap: wrap;
	gap: spacing.$spacing-6;
	margin: spacing.$spacing-0;
	padding: spacing.$spacing-0;
}

.ontario-card-collecton--cards-per-row-4 ::slotted(ontario-card) {
	width: calc(25% - 1.5rem);

	@media screen and (max-width: breakpoints.$medium-breakpoint) {
		width: calc(50% - 1rem);
	}

	@media screen and (max-width: breakpoints.$small-breakpoint) {
		width: 100%;
	}
}

.ontario-card-collecton--cards-per-row-3 ::slotted(ontario-card) {
	width: calc(33.3% - 1.33rem);

	@media screen and (max-width: breakpoints.$small-breakpoint) {
		width: 100%;
	}
}

.ontario-card-collecton--cards-per-row-2 ::slotted(ontario-card) {
	width: calc(50% - 1rem);

	@media screen and (max-width: breakpoints.$small-breakpoint) {
		width: 100%;
	}
}
